import React from 'react';

import {
  ExpandableRowsComponent,
  PaginationChangePage,
  PaginationChangeRowsPerPage,
  PaginationComponentProps,
  TableColumn,
  TableProps as DataTableProps,
} from 'react-data-table-component/dist/DataTable/types';

export type ExpanderComponentProps<T> = {
  data: T;
};

export type TablePaginatorI = PaginationComponentProps;

export type TableProps<T> = {
  columns: TableColumn<T>[];
  data: T[];
  loading?: boolean;
  tableClass?: string;
  container?: React.ComponentType<any>;
  enabledFilters?: FilterConfigurationType;
  fixedFilters?: FilterFixedConfigurationType;
  EmptyComponent?: React.ComponentType<any>;
  PaginatorComponent?: React.ComponentType<TablePaginatorI>;
  FiltersComponent?: TableHeaderComponent;
  onFilter?: (values: ItemFiltered[]) => void;
  onReload?: () => void;
  expandableRowsComponent?: ExpandableRowsComponent<T>;
  rowsPerPage?: number;
  rowCount?: number;
  currentPage?: number;
  onChangePage?: PaginationChangePage;
  onChangeRowsPerPage?: PaginationChangeRowsPerPage;
} & DataTableProps<T>

type ServerFetchFunction = (props: PaginatedFiltrableFunction) => void;

export type SearchFilterType = {
  name: string
  title: string
}

export type PageableFiltrablePage<T> = {
  initialRowPerPage?: number;
  enabledFilters: FilterConfigurationType;
  fixedFilters: FilterFixedConfigurationType;
  serverFetchFunction: ServerFetchFunction;
  searchFilter?: SearchFilterType
} & TableProps<T>

export type TableComponentType<T = any> = React.FC<TableProps<T>>;
export type PageableFiltrablePageComponentType<T = any> = React.FC<PageableFiltrablePage<T>>;

export type TableColumnI<T> = TableColumn<T>;

export type TableHeaderProps = {
  enabledFilters?: FilterConfigurationType;
  fixedFilters: FilterFixedConfigurationType;
  searchFilter?: SearchFilterType
  onFilter?: (values: ItemFiltered[]) => void;
  onReload?: (values: ItemFiltered[]) => void;
};

export type TableHeaderComponent = React.ComponentType<TableHeaderProps>;
// FILTERS
export enum FilterTypes {
  IDENTIFICATION = 'identification',

  SELECT = 'select',
  MULTI_SELECT = 'multi-select',
  MULTI_CHECK = 'multi-check',
  DATE_RANGE = 'date-range',
  DATE = 'date',
  EMAIL = 'email',
  INPUT = 'input',
  LIKE = 'like',
  NUMBER = 'number',
  CUSTOM = 'custom'
}
export type OptionComponentType = {
  placeholder?: string;
  inputLabel?: string;
  name: string;
  agregationRoot: string;
  view: string;
  isMulti?: boolean;
  bodyRequest: object;
}
export type FilterType = {
  key: string;
  name: string | any;
  type: FilterTypes;
  icon?: string;
  options?: Array<{ label: string | any; value: string | number | object }>;
  message?: string;
  component?: React.ComponentType | React.ReactNode;
  optionComponent?: OptionComponentType;
};

export type FilterConfigurationType = {
  [key: string]: FilterType;
};

export type FilterFixedType = {
  values: FilterValue;
  type: FilterTypes;
  isFixed?: boolean;
  isHidden?: boolean;
};
export type FilterFixedConfigurationType = {
  [key: string]: FilterFixedType;
};

export type FilterValuesType = {
  [key: string]: ItemFiltered;
};

export type FilteredValueObject = {
  value: string | number;
  label: string;
};

export type FilterValue = string[] | number[] | FilteredValueObject[];

export interface ItemFiltered {
  id: string;
  key: string;
  type: FilterTypes;
  values: FilterValue;
  isFixed?: boolean;
}

export interface ItemFilterProps extends ItemFiltered {
  label: string;
  config: FilterType;
  onClick: (id: string) => void;
  onRemove: (id: string) => void;
}

export interface PaginatedFunction {
  page: number;
  rowsPerPage: number;
}

export interface FiltrableFunction {
  filters: string | ItemFiltered[];
}

export interface SortableFunction {
  sort?: string;
}

export interface PaginatedFiltrableFunction extends PaginatedFunction, FiltrableFunction, SortableFunction {}
